import { create } from "zustand";
import { generateSampleData } from "../data/sampleData";

const sample = generateSampleData();

export const useData = create((set) => ({
  tables: sample,
  source: "sample",
  setTables: (partial, source = "upload") =>
    set((s) => ({ tables: { ...s.tables, ...partial }, source })),
  resetToSample: () => set({ tables: generateSampleData(), source: "sample" }),
}));

export const useDrivers = create((set) => ({
  grossMarginPct: 75,
  openingArr: 24000000,
  cacBySegment: { Enterprise: 95000, "Mid-Market": 38000, Commercial: 15000 },
  targetCoverage: 3,
  quotaOverrides: {},
  planOverrides: {},
  setDriver: (key, value) => set({ [key]: value }),
  setCac: (segment, value) => set((s) => ({ cacBySegment: { ...s.cacBySegment, [segment]: value } })),
  setQuotaOverride: (rep_id, value) => set((s) => ({ quotaOverrides: { ...s.quotaOverrides, [rep_id]: value } })),
  setPlanOverride: (key, value) => set((s) => ({ planOverrides: { ...s.planOverrides, [key]: value } })),
}));
